import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    username: '',
    isRuleDetail: false // 规则详情查看权限
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
